import { useCart } from 'contexts/cart';
import { EffectiveCart } from 'interfaces/cart';
import { CHECKOUT_STEPS } from 'modules/checkout/constants';
import { useCheckout } from 'modules/checkout/state';
import CartItems from 'modules/express-checkout/common-components/cart-items';
import SummaryPrices from 'modules/express-checkout/common-components/summary-prices';
import React from 'react';
import { CheckoutPriceSummary } from './price-summary';

interface Props {
  summaryCart?: EffectiveCart;
  canRemoveProducts?: boolean;
  additionalComponent?: React.ReactNode;
  hasExistingSubscription?: boolean;
}

export const CheckoutCart: React.FC<Props> = ({
  summaryCart,
  canRemoveProducts = false,
  additionalComponent,
  hasExistingSubscription = false,
}) => {
  const {
    containsPreorderItem,
    containsPreorderItemsOnly,
    effectiveCart: fallbackEffectiveCart,
  } = useCart();
  const { step } = useCheckout();

  const effectiveCart = summaryCart || fallbackEffectiveCart;

  return (
    <div className="lg:bg-other-white lg:rounded-lg lg:shadow-sm">
      <div className="lg:px-6 lg:py-5">
        <CartItems
          gifts={effectiveCart?.gifts?.items}
          items={effectiveCart?.items || []}
          canRemoveProducts={canRemoveProducts}
        />
      </div>
      {effectiveCart && (
        <div className="border-primary-main/10 -mx-4 mt-4 border-t lg:-mx-0 lg:mt-0">
          {hasExistingSubscription ? (
            // Futterabo-Konfigurator: shipping is omitted because it is only calculated when the scheduled order triggers.
            <SummaryPrices
              hasExistingSubscription={hasExistingSubscription}
              canToggleCredits={step !== CHECKOUT_STEPS.CONFIRM}
              containsPreorderItem={containsPreorderItem}
              containsPreorderItemsOnly={containsPreorderItemsOnly}
              itemsTotal={summaryCart?.itemsTotal ?? effectiveCart?.itemsTotal}
              cartTotal={summaryCart?.cartTotal ?? effectiveCart?.cartTotal}
              discount={summaryCart?.discount ?? effectiveCart?.discount}
              shippingPrice={summaryCart?.shipping.price ?? effectiveCart?.shipping.price}
            />
          ) : (
            <CheckoutPriceSummary
              containsPreorderItem={containsPreorderItem}
              containsPreorderItemsOnly={containsPreorderItemsOnly}
              effectiveCart={effectiveCart}
            />
          )}
        </div>
      )}
      {additionalComponent}
    </div>
  );
};
